var $ed6aae4e5f766f1e$exports = {};
$ed6aae4e5f766f1e$exports = {
    "Empty": `\u{641}\u{627}\u{631}\u{63A}`
};


export {$ed6aae4e5f766f1e$exports as default};
//# sourceMappingURL=ar-AE.mjs.map
